import React from 'react';
import parse from "html-react-parser";

import FullWrapper from '../../wrappers/full-wrapper';
import GradingSystem from '../../components/grading-system';
import BottomBanner from '../../components/bottom-banner';

import methodsIcon from 'svg/team/methods.svg'
import technologyIcon from 'svg/team/technology.svg'
import humanIcon from 'svg/team/human.svg'
import rocketIcon from 'svg/team/rocket.svg'
import supportIcon from 'svg/treasures__icon1.svg'
import personalGrowthIcon from 'svg/treasures__icon3.svg'

import './style.sass';
import EmployeeAccount from "../../components/employee-account";

const benefits = [
    {
        title: 'гибкие методики <br /> управления проектами',
        icon: methodsIcon
    },
    {
        title: 'современный <br />технологический стек',
        icon: technologyIcon
    },
    {
        title: 'крупные проекты в финтехе, B2B и инновационной сфере',
        icon: rocketIcon
    },
    {
        title: 'менторская поддержка и внимание тимлидов ',
        icon: supportIcon
    },
    {
        title: 'среда для профессионального и личного роста',
        icon: personalGrowthIcon
    },
    {
        title: 'спортивные традиции и&nbsp;корпоративные мероприятия',
        icon: humanIcon
    },
]

const digitalLearning = () => {
    return (
        <div className="digital-learning">
            <FullWrapper>
                <h1 className="digital-learning__main-title">
                    Развитие в&nbsp;команде
                </h1>
            </FullWrapper>
            <FullWrapper>

                <div className='digital-learning__team-title'>
                    &laquo;Вебпрактик&raquo;&nbsp;&mdash; команда профессионалов в&nbsp;области разработки
                    и&nbsp;маркетинга. Нас объединяет желание расти и&nbsp;работать с&nbsp;интересными задачами, которые
                    приносят пользу клиентам и&nbsp;развивают нас как специалистов.
                </div>

                <div className='digital-learning__team-subtitle'>
                    Мы&nbsp;постоянно осваиваем новые технологии, изучаем тренды цифрового рынка и&nbsp;стремимся
                    к&nbsp;устойчивым результатам.
                </div>

                <div className='digital-learning__work'>
                    <div className='digital-learning__work-title'>
                        Работа в&nbsp;&laquo;Вебпрактик&raquo;&nbsp;&mdash; это
                    </div>

                    <div className='digital-learning__work-benefits'>
                        <div>
                            {benefits.slice(0, 3).map(benefit => (
                                <div className='digital-learning__work-benefit' key={benefit.title}>
                                    <div className='digital-learning__work-benefit-icon'>
                                        <img className='digital-learning__work-benefit-img' src={benefit.icon}
                                             alt='icon'/>
                                    </div>
                                    <div className='digital-learning__work-benefit-title'>
                                        {parse(benefit.title)}
                                    </div>
                                </div>
                            ))}
                        </div>
                        <div>
                            {benefits.slice(3).map(benefit => (
                                <div className='digital-learning__work-benefit' key={benefit.title}>
                                    <div className='digital-learning__work-benefit-icon'>
                                        <img className='digital-learning__work-benefit-img' src={benefit.icon}
                                             alt='icon'/>
                                    </div>
                                    <div className='digital-learning__work-benefit-title'>
                                        {parse(benefit.title)}
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>

                <div className="digital-learning__title">Индивидуальная траектория развития</div>
                <div className="digital-learning__wrapper digital-learning__info--indent-bottom-md">

                    <div className="digital-learning__info ">

                        Для развития и&nbsp;карьерного роста мы&nbsp;используем собственную
                        разработку&nbsp;&mdash; платформу SkillsTeam. Она помогает выстраивать индивидуальную
                        траекторию,
                        видеть текущий уровень и&nbsp;планировать дальнейшее продвижение.
                    </div>
                    <div className="digital-learning__info ">
                        В&nbsp;нашей системе нет жёстких сроков и&nbsp;формального контроля: каждый выбирает свой темп
                        и&nbsp;сам планирует обучение. Прогресс удобно отслеживать в&nbsp;личном
                        кабинете&nbsp;&mdash; по&nbsp;каждой компетенции видно, на&nbsp;каком этапе вы&nbsp;находитесь.
                    </div>
                    <div className="digital-learning__info ">
                        У&nbsp;каждого сотрудника есть наставник. Он&nbsp;помогает освоить сложные темы, проверяет
                        задания
                        и&nbsp;всегда на&nbsp;связи. Мы&nbsp;уверены, что поддержка&nbsp;&mdash; важная часть развития.
                    </div>
                </div>


                <div className="digital-learning__title">Прозрачная система грейдов</div>
                <div className="digital-learning__info digital-learning__info--indent-bottom-md">
                    В&nbsp;личном кабинете <b><a href={'https://skillsteam.ru/'} target={'_blank'} rel="noopener noreferrer" className='digital-learning__link'>SkillsTeam</a></b> можно посмотреть, как изменится уровень зарплаты при переходе
                    на&nbsp;следующий грейд. Вместе с&nbsp;ростом открываются новые задачи, проекты и&nbsp;направления.
                </div>
                <EmployeeAccount/>
                <GradingSystem/>
            </FullWrapper>
            <BottomBanner/>
        </div>

    );
};

export default digitalLearning;
